import { ArrowRight, Sparkles, ShieldCheck, MapPin } from "lucide-react";

const HERO_IMG =
  "https://images.unsplash.com/photo-1711512972476-cf52b296faff?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwzfHxjYXIlMjBjZXJhbWljJTIwY29hdGluZ3xlbnwwfHx8fDE3Nzg0OTQzMzN8MA&ixlib=rb-4.1.0&q=85";

export default function Hero() {
  return (
    <section id="top" className="relative min-h-[100svh] overflow-hidden grain" data-testid="hero-section">
      <div className="absolute inset-0">
        <img
          src={HERO_IMG}
          alt="Black sports car after a full detail"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/40 to-[#050505]" />
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_rgba(255,255,255,0.05)_0%,_transparent_60%)]" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 pt-40 pb-24 lg:pt-48 lg:pb-32">
        <div className="flex items-center gap-2 text-xs uppercase tracking-[0.25em] text-gold reveal">
          <MapPin className="w-3.5 h-3.5" strokeWidth={1.6} />
          Christchurch · New Zealand
        </div>

        <h1
          data-testid="hero-title"
          className="font-display font-black text-5xl sm:text-6xl lg:text-7xl xl:text-8xl mt-6 text-balance leading-[0.95] reveal reveal-delay-1"
        >
          Showroom-grade
          <br />
          <span className="gold-gradient-text">detailing</span>, every time.
        </h1>

        <p className="mt-8 max-w-xl text-neutral-300 text-base sm:text-lg leading-relaxed reveal reveal-delay-2">
          Mobile detailing across Christchurch — we come to you. Hand washed,
          hand polished, treated like our own. Open Tue, Thu &amp; Sat · 9am – 3pm.
        </p>

        <div className="mt-10 flex flex-wrap gap-3 reveal reveal-delay-3">
          <a
            href="#booking"
            data-testid="hero-book-btn"
            className="inline-flex items-center gap-2 bg-white text-black hover:bg-neutral-200 px-6 py-4 text-xs font-bold uppercase tracking-[0.2em] transition-all hover:gap-3"
          >
            Book your detail <ArrowRight className="w-4 h-4" strokeWidth={1.8} />
          </a>
          <a
            href="#services"
            data-testid="hero-services-btn"
            className="inline-flex items-center gap-2 border border-white/20 hover:border-white/60 hover:bg-white/5 px-6 py-4 text-xs font-bold uppercase tracking-[0.2em] transition-all"
          >
            View pricing
          </a>
        </div>

        <div className="mt-16 grid grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 border border-white/10 max-w-3xl reveal reveal-delay-4">
          {[
            { k: "Now", v: "Taking bookings", icon: Sparkles },
            { k: "Tue·Thu·Sat", v: "9am – 3pm" },
            { k: "100%", v: "Care guarantee", icon: ShieldCheck },
            { k: "Mobile", v: "We come to you" },
          ].map((s, i) => (
            <div key={i} className="bg-[#0a0a0a] px-5 py-6">
              <div className="flex items-baseline gap-2">
                <div className="font-display text-2xl sm:text-3xl font-bold">{s.k}</div>
                {s.icon && <s.icon className="w-4 h-4 text-gold" strokeWidth={1.5} />}
              </div>
              <div className="text-[11px] uppercase tracking-[0.18em] text-neutral-500 mt-1">
                {s.v}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Marquee */}
      <div className="relative z-10 border-y border-white/10 bg-black/60 backdrop-blur-md overflow-hidden">
        <div className="flex marquee-track whitespace-nowrap py-4 text-xs uppercase tracking-[0.3em] text-neutral-400">
          {Array.from({ length: 2 }).map((_, i) => (
            <div key={i} className="flex items-center gap-10 px-5">
              <span>Hand wash</span><span>·</span>
              <span>Interior deep clean</span><span>·</span>
              <span>Decontamination</span><span>·</span>
              <span>Tyre dressing</span><span>·</span>
              <span>Glass restoration</span><span>·</span>
              <span>Leather conditioning</span><span>·</span>
              <span>Pet hair removal</span><span>·</span>
              <span>Showroom finish</span><span>·</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
